const eventId = event => event && (event.id || event.messageId)

const eventSequence = event => {
  const value = Number(event && event.sequence)
  return Number.isSafeInteger(value) ? value : null
}

const conversationEventWindowBounds = state => {
  let min = null
  let max = null
  const events = state && state.window && state.window.events
  if (!events || !events.values) return { min, max }
  for (const event of events.values()) {
    const sequence = eventSequence(event)
    if (sequence === null) continue
    min = min === null ? sequence : Math.min(min, sequence)
    max = max === null ? sequence : Math.max(max, sequence)
  }
  return { min, max }
}

const isConversationEventWindowComplete = state => Boolean(
  state &&
  !state.hasOlder &&
  !state.hasNewer
)

const shouldApplyConversationEvent = (state, event) => {
  if (!state || state.reanchoring) return false
  const id = eventId(event)
  if (!id) return false
  if (state.window && state.window.events && state.window.events.has(id)) {
    return true
  }
  if (isConversationEventWindowComplete(state)) return true
  const sequence = eventSequence(event)
  if (sequence === null) return false
  const { min, max } = conversationEventWindowBounds(state)
  if (min === null || max === null) return false
  if (state.anchor === 'oldest') return sequence <= max
  return sequence >= min
}

const partitionConversationEventChanges = (state, events) => {
  if (!state.bufferedLiveEvents) state.bufferedLiveEvents = new Map()
  const visible = []
  for (const event of events || []) {
    const id = eventId(event)
    if (!id) continue
    if (shouldApplyConversationEvent(state, event)) {
      state.bufferedLiveEvents.delete(id)
      visible.push(event)
    } else {
      state.bufferedLiveEvents.set(id, event)
    }
  }
  return visible
}

const takeApplicableBufferedConversationEvents = state => {
  if (!state.bufferedLiveEvents) return []
  const visible = []
  for (const [id, event] of state.bufferedLiveEvents) {
    if (!shouldApplyConversationEvent(state, event)) continue
    state.bufferedLiveEvents.delete(id)
    visible.push(event)
  }
  return visible
}

module.exports = {
  conversationEventWindowBounds,
  isConversationEventWindowComplete,
  partitionConversationEventChanges,
  shouldApplyConversationEvent,
  takeApplicableBufferedConversationEvents
}
